import { render, staticRenderFns } from "./seal.vue?vue&type=template&id=5c774ffe&scoped=true&"
import script from "./seal.vue?vue&type=script&lang=js&"
export * from "./seal.vue?vue&type=script&lang=js&"
import style0 from "./seal.vue?vue&type=style&index=0&id=5c774ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c774ffe",
  null
  
)

export default component.exports